import Show from 'Components/Show/Show'
import React from 'react'
import MaskPhoneNumber from 'Utils/MaskPhoneNumber'

const RequestPaymentMethod = ({ paymentModel, handlePaymentMethod, validationModel }) => {
    return (
        <div>
            <div className="flex items-center">
                <input type="radio" id="PAY_REQ" name="patientPaymentType" value="PAY_REQ" checked={paymentModel.patientPaymentType === 'PAY_REQ'} onChange={handlePaymentMethod} className="w-4 h-4 text-blue-600 focus:ring-blue-500" />
                <label htmlFor="PAY_REQ" className="ml-3 text-sm text-slate-700">Request Payment</label>
            </div>
            <Show when={paymentModel.patientPaymentType === 'PAY_REQ'}>
                <div className="mt-2 space-y-2 ml-7">
                    <div className="flex items-center gap-4">
                        <div className="flex items-center">
                            <input type="radio" id="Email" name="requestedVia" value="Email" checked={paymentModel.requestedVia === 'Email'} onChange={handlePaymentMethod} className="w-4 h-4 text-blue-600 focus:ring-blue-500" />
                            <label htmlFor="Email" className="ml-2 text-sm text-slate-700">Email</label>
                        </div>
                        <div className="flex items-center">
                            <input type="radio" id="Text" name="requestedVia" value="Text" checked={paymentModel.requestedVia === 'Text'} onChange={handlePaymentMethod} className="w-4 h-4 text-blue-600 focus:ring-blue-500" />
                            <label htmlFor="Text" className="ml-2 text-sm text-slate-700">Text</label>
                        </div>
                    </div>
                    <Show when={paymentModel.requestedVia === 'Email'}>
                        <input type="email" value={paymentModel.requestEmail} onChange={handlePaymentMethod} name="requestEmail" placeholder="Email Address" className="w-full px-3 py-2 text-sm border rounded-lg border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        {validationModel.requestEmailError}
                    </Show>
                    <Show when={paymentModel.requestedVia === 'Text'}>
                        <input type="tel" value={MaskPhoneNumber(paymentModel.requestPhone, "generatemask")} onChange={handlePaymentMethod} name="requestPhone" placeholder="Phone Number" className="w-full px-3 py-2 text-sm border rounded-lg border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        {validationModel.requestPhoneError}
                    </Show>

                </div>
            </Show>

        </div>
    )
}

export default RequestPaymentMethod